import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getSkills } from '@/redux/requests/skillsRequests.js';
import SkillEditorPage from './pages/SkillEditorPage.jsx';
import SkillsPage from './pages/SkillsPage.jsx';
import './styles/skills.css';

/** Skills: the list, and one skill open to write or edit (`/skills/new` starts a new one). */
const SkillsScreen = () => {
  const { skillId } = useParams();

  useEffect(() => {
    getSkills();
  }, []);

  return skillId ? <SkillEditorPage key={skillId} skillId={skillId} /> : <SkillsPage />;
};

export default SkillsScreen;
